import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "../../config/config.service";
import { AboutData } from "../models/about.model";

@Injectable({
    providedIn: 'root'
})
export class AboutService {

    constructor(private http: HttpClient, private configService: ConfigService) { }

    customerNotes(): Observable<AboutData> {
        return this.http.get<AboutData>(`${this.configService.environment.doc.url}/about`);
    }

    partnerNotes(): Observable<AboutData> {
        return this.http.get<AboutData>(`${this.configService.environment.doc.url}/about/partner`);
    }

    internalNotes(): Observable<AboutData> {
        return this.http.get<AboutData>(`${this.configService.environment.doc.url}/about/internal`);
    }
}
